import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { PureComponent } from 'react';
import { Paragraph } from '../../typography';

var FormFieldHint =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FormFieldHint, _PureComponent);

  function FormFieldHint() {
    _classCallCheck(this, FormFieldHint);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormFieldHint).apply(this, arguments));
  }

  _createClass(FormFieldHint, [{
    key: "render",
    value: function render() {
      return React.createElement(Paragraph, _extends({
        marginTop: 0,
        size: 300,
        color: "muted"
      }, this.props));
    }
  }]);

  return FormFieldHint;
}(PureComponent);

FormFieldHint.displayName = "FormFieldHint";

_defineProperty(FormFieldHint, "propTypes", _objectSpread({}, Paragraph.propTypes));

export { FormFieldHint as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9mb3JtLWZpZWxkL3NyYy9Gb3JtRmllbGRIaW50LmpzIl0sIm5hbWVzIjpbIlJlYWN0IiwiUHVyZUNvbXBvbmVudCIsIlBhcmFncmFwaCIsIkZvcm1GaWVsZEhpbnQiLCJwcm9wcyIsInByb3BUeXBlcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsT0FBT0EsS0FBUCxJQUFnQkMsYUFBaEIsUUFBcUMsT0FBckM7QUFDQSxTQUFTQyxTQUFULFFBQTBCLGtCQUExQjs7SUFFcUJDLGE7Ozs7Ozs7Ozs7Ozs7NkJBUVY7QUFDUCxhQUFPLG9CQUFDLFNBQUQ7QUFBVyxRQUFBLFNBQVMsRUFBRSxDQUF0QjtBQUF5QixRQUFBLElBQUksRUFBRSxHQUEvQjtBQUFvQyxRQUFBLEtBQUssRUFBQztBQUExQyxTQUFzRCxLQUFLQyxLQUEzRCxFQUFQO0FBQ0Q7Ozs7RUFWd0NILGE7O0FBQXRCRSxhOztnQkFBQUEsYSxpQ0FLZEQsU0FBUyxDQUFDRyxTOztTQUxJRixhIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IFB1cmVDb21wb25lbnQgfSBmcm9tICdyZWFjdCdcbmltcG9ydCB7IFBhcmFncmFwaCB9IGZyb20gJy4uLy4uL3R5cG9ncmFwaHknXG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIEZvcm1GaWVsZEhpbnQgZXh0ZW5kcyBQdXJlQ29tcG9uZW50IHtcbiAgc3RhdGljIHByb3BUeXBlcyA9IHtcbiAgICAvKipcbiAgICAgKiBDb21wb3NlcyB0aGUgUGFyYWdyYXBoIGNvbXBvbmVudCBhcyB0aGUgYmFzZS5cbiAgICAgKi9cbiAgICAuLi5QYXJhZ3JhcGgucHJvcFR5cGVzXG4gIH1cblxuICByZW5kZXIoKSB7XG4gICAgcmV0dXJuIDxQYXJhZ3JhcGggbWFyZ2luVG9wPXswfSBzaXplPXszMDB9IGNvbG9yPVwibXV0ZWRcIiB7Li4udGhpcy5wcm9wc30gLz5cbiAgfVxufVxuIl19